export const arrayDiff = (array1, array2) => array1.filter((item) => !array2.includes(item));

export const arraySymetricDiff = (array1, array2) => array1
    .filter((item) => !array2.includes(item))
    .concat(array2.filter((item) => !array1.includes(item)));

export const serializeAnnotationArray = (annotations) => annotations.map((annotation) => {
    const { context, ...rest } = annotation;

    return annotation.context ? {
        ...rest,
        '@context': annotation.context
    } : rest;
});

// This function was created to calculate current (css) pixel per inch so one can calculate where
// is the annotationon the PDF. PDF has it's own PPI
export const getPPI = () => {
    // create an empty element
    const div = document.createElement('div');

    // give it an absolute size of one inch
    div.style.width='1in';

    // append it to the body
    const body = document.getElementsByTagName('body')[0];
    body.appendChild(div);

    // read the computed width
    const ppi = window.getComputedStyle(div, null).getPropertyValue('width');

    // remove it again
    body.removeChild(div);

    // and return the value
    return parseFloat(ppi);
};
